import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=353e355e&scoped=true"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=353e355e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e355e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353e355e')) {
      api.createRecord('353e355e', component.options)
    } else {
      api.reload('353e355e', component.options)
    }
    module.hot.accept("./ModalForm.vue?vue&type=template&id=353e355e&scoped=true", function () {
      api.rerender('353e355e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/BussinessAndBranch/ModalForm.vue"
export default component.exports